var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg028DownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2C11.4477 2 10.9999 2.44772 10.9999 3V18.59L5.70994 13.29C5.31782 12.8979 4.68206 12.8979 4.28994 13.29C3.89782 13.6821 3.89782 14.3179 4.28994 14.71L11.2899 21.71C11.4777 21.8993 11.7333 22.0058 11.9999 22.0058C12.2666 22.0058 12.5222 21.8993 12.7099 21.71L19.7099 14.71C19.9636 14.4563 20.0627 14.0866 19.9698 13.7401C19.877 13.3936 19.6063 13.123 19.2598 13.0301C18.9133 12.9373 18.5436 13.0363 18.2899 13.29L12.9999 18.59V3C12.9999 2.44772 12.5522 2 11.9999 2Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg028DownArrow);
export default __webpack_public_path__ + "static/media/028-down-arrow.e633cd5077b378e7f394e93f487769e5.svg";
export { ForwardRef as ReactComponent };